import React from 'react';
import { UserAction } from '../api';
import { ItemTypeIcon } from './DigitalItemCard';

const itemLabels: Record<string, string> = {
  CommonItem: 'Common Item', UniqueItem: 'Unique Item', Spell: 'Spell', Skill: 'Skill', Ally: 'Ally',
  Special: 'Special', SpecialCard: 'Special', Injury: 'Injury', Madness: 'Madness', Exhibit: 'Exhibit',
};
const paths: Record<string, string> = {
  Clue: 'M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm5 12 6 6',
  Monster: 'M5 8 3 2l7 4h4l7-4-2 6v8l-4 6H9l-4-6V8Zm3 3h2m4 0h2M9 17h6',
  Gate: 'M4 21V10a8 8 0 0 1 16 0v11M8 21V10a4 4 0 0 1 8 0v11M2 21h20',
  Investigator: 'M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM4 22v-3a8 8 0 0 1 16 0v3',
  encounter: 'M12 5v16M3 4c4-1 6 0 9 2 3-2 5-3 9-2v15c-4-1-6 0-9 2-3-2-5-3-9-2Z',
  movement: 'M3 12h18m-7-7 7 7-7 7',
  continue: 'm5 12 4 4L19 6',
  undo: 'M4 10a9 9 0 1 1 0 6M3 3v7h7',
  fight: 'm4 3 17 17m-6 0 5-5M3 4l17 17M3 3l5 1-4 4Z',
  evade: 'M3 12h18m-7-7 7 7-7 7',
  trade: 'M3 7h18m-5-4 5 4-5 4M21 17H3m5-4-5 4 5 4',
  skills: 'M4 5h16M4 12h16M4 19h16M8 2v6m8 1v6M9 16v6',
  generic: 'M4 3h16v18H4V3Zm4 5h8M8 12h8M8 16h5',
  'setup-none': 'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM6 6l12 12',
  'setup-random': 'M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2ZM7 7h.01M17 7h.01M12 12h.01M7 17h.01M17 17h.01',
};

export function actionIconKind(action: UserAction, kind?: string) {
  if (/^select_random_/.test(action.id)) return 'setup-random';
  if (/^select_no_(herald|guardian|institution)(_|$)/.test(action.id)) return 'setup-none';
  if (action.cardType) return action.cardType;
  if (kind) return kind;
  if (action.sliderPosition != null) return 'skills';
  if (action.trade || /exchange|trade/i.test(action.id)) return 'trade';
  if (/^Undo/.test(action.id)) return 'undo';
  if (/encounter/i.test(`${action.id} ${action.name}`)) return 'encounter';
  if (/^(move|return|enter)_|^move$/i.test(action.id)) return 'movement';
  if (/^(end_|finish|continue|pass_|.*_ack$)|roll.dice/i.test(action.id + ' ' + action.name)) return 'continue';
  return 'generic';
}

/** Generic object symbols deliberately do not inspect card artwork or item subtypes. */
export function ActionTypeIcon({ action, kind }: { action: UserAction; kind?: string }) {
  const name = actionIconKind(action, kind);
  return <span className="game-quick-action-icon" data-icon={name} aria-hidden="true">
    {itemLabels[name] ? <ItemTypeIcon label={itemLabels[name]} />
      : <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" focusable="false">
        <path d={paths[name] || paths.generic} />
      </svg>}
  </span>;
}
